<!--  CHECKBOX  -->

<div class="form-control checkbox-control" [formGroup]="form" [class.invalid]="isInvalid()" [class.valid]="isValid()">
	<!--  HIDDEN INPUT  -->

	<input
		id="control"
		type="checkbox"
		[id]="form_control_id"
		[attr.name]="form_control_name"
		[formControlName]="form_control_name"
		[ngClass]="input_css_class"
		(change)="onChange()"
	/>

	<!--  END HIDDEN INPUT  -->

	<!--  LABEL  -->

	<span class="checkbox-label">
		<label for="control" [for]="form_control_id" [class.checked]="!!form_control.value">
			<span class="check-background"></span>
			<i class="icon-tick check-tick"></i>

			<!--  LABEL PARTS LOOP  -->

			<span *ngFor="let label_part of label_parts">
				<a *ngIf="isCta(label_part)" (click)="onCta($event, label_part)">{{ getCtaText(label_part) }}</a>
				<span *ngIf="!isCta(label_part)">{{ label_part }}</span>
			</span>

			<!--  END LABEL PARTS LOOP  -->
		</label>
	</span>

	<!--  END LABEL  -->

	<!--  INFO  -->

	<span *ngIf="info !== null" class="info" [class.highlighted]="highlighted_info">{{ info }}</span>

	<!-- END INFO  -->

	<!--  ERROR  -->

	<span *ngIf="isInvalid()" class="error">This is a required field</span>

	<!-- END ERROR  -->
</div>

<!--  END CHECKBOX  -->
